export enum InstallPosition {
  WidgetPanel,
  Dashboard
}
